import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom-v5';
import { theme } from '@ovotech/element-v5';

export const BackLink = styled(RouterLink)`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[100]};
  align-self: flex-start;
  color: ${theme.color.brand.dark};
  font-weight: bold;
  text-decoration: none;
`;
